export const openModal = (modal) => {
  const body = document.body;

  modal.classList.add("opened");
  body.classList.add("no-scroll");
}
